<template>
  <div class="m-market-normal">
    <template v-for="(ids, index) in rowList">
      <div
        :key="index"
        :class="['m-market-row', `m-market-row--${step}`]"
      >
        <template v-for="outcomeId in ids">
          <Outcome
            :key="outcomeId"
            class="has-desc"
            :outcome="outcomesMap[outcomeId]"
            :market="market"
            :event="event"
            show-desc
          />
        </template>

        <!-- 用来占位，以保持布局自适应宽度 -->
        <template v-for="item in (step - ids.length)">
          <div
            :key="item"
            class="m-place-outcome"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 五、不需调整的Market
 * Market中outcome数量较少（2至4个），非组合类的则无需调整；例如1x2，DC，DNB等
 */

import Outcome from 'wap/match/Event/pagelet/Outcome'

export default {
  name: 'Market5Normal',
  components: {
    Outcome
  },
  props: {
    market: {
      type: Object,
      default: () => ({})
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      outcomesMap: {},
      step: 2,
      rowList: []
    }
  },
  computed: {
    checkIsActive() {
      const { market } = this
      return market.status
    }
  },
  watch: {
    'market.outcomes.order'(val) {
      if (val) {
        this.getOutcomesMap()
        this.getStep()
        this.getRowList()
      }
    },
    checkIsActive: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.market.marketTypeDesc) return false
        this._timer && clearTimeout(this._timer)
        const option = this.market.marketTypeDesc.split('-')
        if (val !== 2 || (oldVal === undefined && val === 2)) {
          this.$emit('checkDeactive', val !== 2, option)
          return false
        }

        this._timer = setTimeout(() => {
          this.$emit('checkDeactive', val !== 2, option)
          clearTimeout(this._timer)
        }, 5000)
      }
    }
  },
  created() {
    this.getOutcomesMap()
    this.getStep()
    this.getRowList()
  },
  methods: {
    getOutcomesMap() {
      this.outcomesMap = this.market.outcomes ? this.market.outcomes.map : null
    },
    getStep() {
      const list = this.market.outcomes ? this.market.outcomes.order : []
      const len = list.length
      this.step = len % 2 === 0 ? 2 : 3
    },
    getRowList() {
      const list = this.market.outcomes ? this.market.outcomes.order : []
      const len = list.length
      const step = this.step
      const result = []
      for (let i = 0; i < len; i += step) {
        result.push(list.slice(i, i + step))
      }
      this.rowList = result
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-market-normal {
  .m-market-row {
    align-items: stretch;
    margin: 0;

    &:last-child {
      .m-outcome {
        margin-bottom: 0;
      }
    }

    .m-outcome {
      margin-bottom: 4/@rem;
    }

    .m-place-outcome {
      flex: 1;
      padding: 0 10/@rem;
    }
  }
}
</style>
